import {
    AtlassianIcon,
    AtlassianAnalyticsIcon,
    BitbucketIcon,
    CompassIcon,
    ConfluenceIcon,
    CustomerServiceManagementIcon,
    GuardIcon,
    JiraAlignIcon,
    JiraIcon,
    JiraProductDiscoveryIcon,
    JiraServiceManagementIcon,
    LoomIcon,
    OpsgenieIcon,
    RovoIcon,
    StatuspageIcon,
    TrelloIcon
} from '@atlaskit/logo';

// the @atlaskit/logo and @atlaskit/icon packages use different size parameters to
// achieve the same size. Including size parameter here with data.
const logoSize = 'xsmall';

export default {
    AtlassianIcon: {
        componentName: 'AtlassianIcon',
        component: AtlassianIcon,
        keywords: ['product', 'logo', 'atlassian'],
        package: '@atlaskit/logo/dist/esm/AtlassianLogo/Icon',
        size: logoSize
    },
    AtlassianAnalyticsIcon: {
        componentName: 'AtlassianAnalyticsIcon',
        component: AtlassianAnalyticsIcon,
        keywords: ['product', 'logo', 'atlassian', 'analytics'],
        package: '@atlaskit/logo/dist/esm/AtlassianAnalyticsLogo/Icon',
        size: logoSize
    },
    BitbucketIcon: {
        componentName: 'BitbucketIcon',
        component: BitbucketIcon,
        keywords: ['product', 'logo', 'bitbucket'],
        package: '@atlaskit/logo/dist/esm/BitbucketLogo/Icon',
        size: logoSize
    },
    CompassIcon: {
        componentName: 'CompassIcon',
        component: CompassIcon,
        keywords: ['product', 'logo', 'compass'],
        package: '@atlaskit/logo/dist/esm/CompassLogo/Icon',
        size: logoSize
    },
    ConfluenceIcon: {
        componentName: 'ConfluenceIcon',
        component: ConfluenceIcon,
        keywords: ['product', 'logo', 'confluence'],
        package: '@atlaskit/logo/dist/esm/ConfluenceLogo/Icon',
        size: logoSize
    },
    CustomerServiceManagementIcon: {
        componentName: 'CustomerServiceManagementIcon',
        component: CustomerServiceManagementIcon,
        keywords: ['product', 'logo', 'customer', 'service', 'management'],
        package: '@atlaskit/logo/dist/esm/CustomerServiceManagementLogo/Icon',
        size: logoSize
    },
    GuardIcon: {
        componentName: 'GuardIcon',
        component: GuardIcon,
        keywords: ['product', 'logo', 'guard'],
        package: '@atlaskit/logo/dist/esm/GuardLogo/Icon',
        size: logoSize
    },
    JiraAlignIcon: {
        componentName: 'JiraAlignIcon',
        component: JiraAlignIcon,
        keywords: ['product', 'logo', 'jira', 'align'],
        package: '@atlaskit/logo/dist/esm/JiraAlignLogo/Icon',
        size: logoSize
    },
    JiraProductDiscoveryIcon: {
        componentName: 'JiraProductDiscoveryIcon',
        component: JiraProductDiscoveryIcon,
        keywords: ['product', 'logo', 'jira', 'product', 'discovery'],
        package: '@atlaskit/logo/dist/esm/JiraProductDiscoveryLogo/Icon',
        size: logoSize
    },
    JiraServiceManagementIcon: {
        componentName: 'JiraServiceManagementIcon',
        component: JiraServiceManagementIcon,
        keywords: ['product', 'logo', 'jira', 'service', 'management'],
        package: '@atlaskit/logo/dist/esm/JiraServiceManagementLogo/Icon',
        size: logoSize
    },
    JiraIcon: {
        componentName: 'JiraIcon',
        component: JiraIcon,
        keywords: ['product', 'logo', 'jira'],
        package: '@atlaskit/logo/dist/esm/JiraLogo/Icon',
        size: logoSize
    },
    LoomIcon: {
        componentName: 'LoomIcon',
        component: LoomIcon,
        keywords: ['product', 'logo', 'loom'],
        package: '@atlaskit/logo/dist/esm/LoomLogo/Icon',
        size: logoSize
    },
    OpsgenieIcon: {
        componentName: 'OpsgenieIcon',
        component: OpsgenieIcon,
        keywords: ['product', 'logo', 'opsgenie'],
        package: '@atlaskit/logo/dist/esm/OpsgenieLogo/Icon',
        size: logoSize
    },
    RovoIcon: {
        componentName: 'RovoIcon',
        component: RovoIcon,
        keywords: ['product', 'logo', 'rovo'],
        package: '@atlaskit/logo/dist/esm/RovoLogo/Icon',
        size: logoSize
    },
    StatuspageIcon: {
        componentName: 'StatuspageIcon',
        component: StatuspageIcon,
        keywords: ['product', 'logo', 'statuspage'],
        package: '@atlaskit/logo/dist/esm/StatuspageLogo/Icon',
        size: logoSize
    },
    TrelloIcon: {
        componentName: 'TrelloIcon',
        component: TrelloIcon,
        keywords: ['product', 'logo', 'trello'],
        package: '@atlaskit/logo/dist/esm/TrelloLogo/Icon',
        size: logoSize
    }
};
